"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCollaborateService = void 0;
const react_1 = require("react");
function useCollaborateService({ loadUsers, onAddUser, onRemoveUser, onSearchTermChange, onSearchTermPaginate, }) {
    const [isSearchingLoading, setIsSearchingLoading] = (0, react_1.useState)(false);
    const [isPaginating, setIsPaginating] = (0, react_1.useState)(false);
    const [isUserListLoading, setIsUserListLoading] = (0, react_1.useState)(true);
    const [userSearch, setUserSearch] = (0, react_1.useState)([]);
    const [userList, setUserList] = (0, react_1.useState)([]);
    const [searchTerm, setSearchTerm] = (0, react_1.useState)('');
    const handleSearchTermChange = (0, react_1.useCallback)((value) => {
        if (value !== '') {
            setIsSearchingLoading(true);
            onSearchTermChange(value).then((response) => {
                setIsSearchingLoading(false);
                setUserSearch(response.filter((userFromSearch) => !userList.find((userFromList) => userFromSearch.id === userFromList.id)));
            });
        }
        setSearchTerm(value);
    }, [onSearchTermChange, userList]);
    const handleSearchTermPaginate = (0, react_1.useCallback)((value) => {
        setIsPaginating(true);
        return onSearchTermPaginate(value).then((response) => {
            setIsPaginating(false);
            if (!response || response.length === 0) {
                return response;
            }
            setUserSearch((state) => [
                ...state,
                ...response.filter((userFromSearch) => !userList.find((userFromList) => userFromSearch.id === userFromList.id)),
            ]);
            return response;
        });
    }, [onSearchTermPaginate, userList]);
    const loadItems = (0, react_1.useCallback)(() => {
        setIsUserListLoading(true);
        loadUsers().then((response) => {
            setUserList(response);
            setIsUserListLoading(false);
        });
    }, [loadUsers]);
    const handleAddUser = (0, react_1.useCallback)((user) => {
        onAddUser(user).then(() => {
            loadItems();
        });
        setSearchTerm('');
    }, [loadItems, onAddUser]);
    const handleRemoveUser = (0, react_1.useCallback)((user) => {
        onRemoveUser(user).then(() => {
            loadItems();
        });
    }, [loadItems, onRemoveUser]);
    (0, react_1.useEffect)(function preloadUserList() {
        loadItems();
    }, [loadItems]);
    return {
        isUserListLoading,
        isPaginating,
        isSearchingLoading,
        searchTerm,
        userList,
        userSearch,
        handleSearchTermChange,
        handleSearchTermPaginate,
        handleAddUser,
        handleRemoveUser,
    };
}
exports.useCollaborateService = useCollaborateService;
//# sourceMappingURL=useCollaborateService.js.map